<template>
  <v-app>
    <component :is="$route.meta.layout || 'div'">
      <router-view />
    </component>
    <ErrorDialog ref="errorDialog" />
  </v-app>
</template>
<script>
import ErrorDialog from '@/components/dialogs/ErrorDialog.vue'

export default {
  name: 'App',
  components: {
    ErrorDialog,
  },
  data() {
    return {
      showError: false,
      error: {},
    }
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.showError = false
      }
    },
  },
  created() {
    this.$eventBus.$on('error400', (error) => {
      this.$root.$errorDialog.open('', error)
    })
    this.$eventBus.$on('error500', (error) => {
      this.$root.$errorDialog.open('SYSTÉM JE DOČASNĚ NEDOSTUPNÝ', error)
    })
    this.$eventBus.$on('errorNetwork', (error) => {
      this.$root.$errorDialog.open('SYSTÉM JE DOČASNĚ NEDOSTUPNÝ', error)
    })
    this.$eventBus.$on('fileNotFound', (error) => {
      this.$root.$errorDialog.open('SOUBOR NEBYL NALEZEN', error)
    })
  },
  mounted() {
    this.$root.$errorDialog = this.$refs.errorDialog
    this.$root.$confirmationDialog = this.$refs.confirmationDialog
    this.$root.$userDeleteDialog = this.$refs.userDeleteDialog
  },
}
</script>
